import RecommendedTrails from "th/recommendedTrails";

export { RecommendedTrails };

customElements.define(
  "th-recommended-trails",
  RecommendedTrails.CustomElementConstructor
);
